// extracted by mini-css-extract-plugin
export default {"select":"MuiMultiSelect-module__select--yMk8z"};